import { CashoutErrorType } from '@bpos/v1/cashout';

import { PayoutError } from './payout-error';

export class BetNotAllowedForEarlyPayout extends PayoutError {
    readonly reason: BetEarlyPayoutNotAllowedReason;

    constructor(reason?: BetEarlyPayoutNotAllowedReason) {
        super();
        this.type = CashoutErrorType.BetNotAllowedForCashout;
        if (reason) {
            this.reason = reason || BetEarlyPayoutNotAllowedReason.Unknown;
        } else {
            this.reason = BetEarlyPayoutNotAllowedReason.Unknown;
        }
    }
}

export enum BetEarlyPayoutNotAllowedReason {
    PaidWithFreeBet = 'PaidWithFreeBet',
    BetBlockedForCashout = 'BetBlockedForCashout',
    BetProtected = 'BetProtected',
    GeoLocationFailed = 'GeoLocationFailed',
    MarketTemplateNotAllowed = 'MarketTemplateNotAllowed',
    BetBlockedForEarlyPayout = 'BetBlockedForEarlyPayout',
    ParallelGamePlayPrevention = 'ParallelGamePlayPrevention',

    PlayerNotRegisteredWithCFR = 'PlayerNotRegisteredWithCFR',
    UserIsSelfExcluded = 'UserIsSelfExcluded',
    OasisDown = 'OasisDown',
    NotBasicModel = 'NotBasicModel',
    System = 'System',
    TaxApplied = 'TaxApplied',
    Unknown = 'Unknown',
}
